import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { useAuth } from "@/lib/AuthContext";
import { hasModule } from "@/lib/auth";

/** Страница модуля: без включённого модуля — «страница недоступна». */
export function RequireModule({ module, children }: { module: string; children: ReactNode }) {
  const { user } = useAuth();
  const { t } = useTranslation();
  if (hasModule(user, module)) return <>{children}</>;
  return (
    <div className="card p-10 text-center">
      <p className="text-text-muted mt-2">{t("common.moduleDisabled")}</p>
    </div>
  );
}
